import React from 'react'
import styled from 'styled-components'
import securityData from '../../images/svg/securityData.svg'
import securityCommerce from '../../images/svg/securityCommerce.svg'
import cardsIcon from '../../images/svg/cardsIcon.svg'

const Footer = styled.footer`
    display: flex;
    align-items: center;
    height:220px;
    background-color: #e4e4e467;
    @media screen and (max-width:820px){
        background-color: transparent;

        display: flex;
        flex-direction: column;
        align-items: center;
    }
`

const ColumPrimary = styled.div`

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    padding-top:0.6rem;
    padding-bottom: 1.2rem;
    background-color: transparent;

    p{
        text-align: left;
        margin-bottom: 1.9rem;
    }

    .textPrimary{
        text-transform: uppercase;
        font-size: 17px;
        height: 1px;
        color:#515151;
        font-family: "Lato", serif;
        font-weight: 700;
        margin-bottom: 1.5rem;
    }

    .textSecondary{
        
        text-transform: uppercase;
        font-size: 17px;
        height: 1px;
        color:#515151;
        font-family: "Lato", serif;
        font-weight: 700;
    }

    .textMail{
        font-size: 16px;
        height: 1px;
        color:#515151;
        font-family: "Lato", serif;
        font-weight: 700;
    }

    
    .cards_icon{
        margin-top: 1.0rem;
        width: 220px;
    }

    @media screen and (max-width:820px){
        background-color: white;

        display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    padding-bottom: 1.2rem;
    background-color:white;

    .cards_icon{
        width: 220px;
    }

    .textPrimary{
        text-transform: uppercase;
        font-size: 17px;
        height: 1px;
        color:#515151;
        font-family: "Lato", serif;
        font-weight: 700;
    }

    .textSecondary{
        text-transform: uppercase;
        font-size: 17px;
        height: 1px;
        color:#515151;
        font-family: "Lato", serif;
        font-weight: 700;
    }

    .textMail{
        font-size: 16px;
        height: 1px;
        color:#515151;
        font-family: "Lato", serif;
        font-weight: 700;
    }

    }

`

const ColumSecondary = styled.div`

    .textAbout{
        display: none;
    }

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    background-color: transparent;

    .textPrimary{
        text-transform: uppercase;
        font-size: 17px;
        height: 1px;
        color:#515151;
        font-family: "Lato", serif;
        font-weight: 700;
    }


    img{
        margin-top: 1rem;
        margin-bottom: 0.5rem;
    }

`

const CardItem = styled.div`
    display: flex;
    align-items: center;

    svg{
        position: relative;
        top: -4px;
        left: -5px;
    }

`

const FooterPayment = () =>{ 

    return(
        <Footer>
            <ColumPrimary>
            <p className='textPrimary'>Atendimento</p>
            <CardItem>
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_32_217)">
            <path d="M11.0478 6.05644C10.4538 5.80325 9.82741 5.67725 9.1638 5.67725H9.1458C7.2258 5.67725 5.6082 6.71165 4.4658 8.66644C3.9894 9.48124 3.6342 10.356 3.4134 11.2836C3.1926 12.2137 3.07739 13.0632 3.07739 13.8312C3.07739 15.5221 3.61739 16.5301 4.51019 16.5301H13.8162C14.7006 16.5301 15.2454 15.5221 15.249 13.8505C15.2538 12.2053 14.7762 10.1725 13.7538 8.54165C13.0686 7.44726 12.2406 6.56406 11.0478 6.05646L11.0478 6.05644ZM14.2494 13.8504C14.2434 14.9736 13.9578 15.6012 13.8162 15.5484H4.50901C4.34942 15.5916 4.04941 14.9892 4.04941 13.8312C4.04941 13.1424 4.15261 12.372 4.35901 11.532C4.56781 10.6812 4.89541 9.88803 5.32381 9.15242C5.69221 8.51882 6.11581 7.99682 6.73981 7.48802C7.37222 6.97323 8.21701 6.65761 9.14582 6.65761H9.16382C10.0926 6.65761 10.9398 6.97801 11.5698 7.49762C12.2046 8.02203 12.6258 8.53921 13.0026 9.17883C13.4394 9.91802 13.7538 10.7172 13.9578 11.5668C14.1606 12.4092 14.253 13.17 14.2494 13.8504L14.2494 13.8504Z" fill="#777777"/>
            <path d="M9.1627 8.8512C8.3491 8.8512 7.6591 9.1344 7.0831 9.7104C6.5083 10.2864 6.2251 10.9752 6.2251 11.7804C6.2251 12.5844 6.5083 13.284 7.0831 13.8588C7.65791 14.4348 8.3479 14.718 9.1627 14.718C9.9679 14.718 10.6579 14.4348 11.2327 13.8588C11.8075 13.2852 12.1003 12.5844 12.1003 11.7804C12.1003 10.974 11.8087 10.2936 11.2327 9.72C10.6579 9.144 9.9679 8.8512 9.1627 8.8512ZM10.5427 13.17C10.1647 13.5516 9.7027 13.7436 9.1627 13.7436C8.6227 13.7436 8.15229 13.5516 7.7731 13.17C7.3903 12.7836 7.2067 12.3204 7.2067 11.7804C7.2067 11.2404 7.39269 10.7808 7.7731 10.4004C8.15351 10.0188 8.6227 9.82439 9.1627 9.82439C9.7027 9.82439 10.1623 10.0188 10.5427 10.4004C10.9231 10.7796 11.1175 11.2404 11.1175 11.7804C11.1187 12.3204 10.9255 12.7824 10.5427 13.17Z" fill="#777777"/>
            <path d="M17.3287 4.02122C16.7887 3.46442 16.0795 3.01921 15.1879 2.68442C13.4071 2.01842 11.2339 1.65723 8.94194 1.65723C7.15514 1.65723 5.56274 1.85162 4.16473 2.23323C2.77513 2.61242 1.74313 3.15603 1.05913 3.84363C0.450736 4.45682 0.157937 5.13603 0.174724 5.89682L0.156724 6.22323C0.149517 6.51603 0.147126 6.74643 0.156724 6.92163C0.165126 7.09203 0.201126 7.30323 0.280316 7.56003C0.359505 7.81683 0.486718 8.01724 0.642724 8.17924C0.964316 8.51284 1.44793 8.68324 2.09352 8.68324C2.27951 8.68324 2.42112 8.67963 2.52671 8.66643C3.82751 8.49484 4.43951 8.14563 4.68552 7.57803C4.86552 7.16523 4.88951 6.87004 4.88951 6.33004V6.12843L4.99632 5.91484C5.25311 5.65804 5.76671 5.46004 6.53591 5.29563C7.30631 5.13123 8.17272 5.04843 9.12791 5.04843C9.96792 5.04843 10.7287 5.11084 11.4103 5.22363C12.0919 5.33884 12.6031 5.48404 12.9403 5.64843C13.2751 5.81284 13.4539 5.96763 13.4539 6.12722V6.27602C13.4539 6.83521 13.4515 7.13522 13.6303 7.55882C13.7167 7.76281 13.8427 7.94042 14.0107 8.07242C14.3383 8.32922 14.9395 8.56921 15.8155 8.66522C16.6387 8.75642 17.2603 8.59682 17.6551 8.19481C17.9767 7.86962 18.1303 7.27562 18.1411 6.91321C18.1471 6.726 18.1495 6.49801 18.1495 6.20521V5.91242C18.1519 5.20681 17.8687 4.57801 17.3287 4.02122H17.3287ZM17.1691 6.22441C17.1691 6.906 17.1271 7.33201 16.9567 7.50721C16.8259 7.64161 16.5763 7.7112 16.2307 7.7112C16.0975 7.7112 15.9919 7.70041 15.9211 7.69201C15.1867 7.62001 14.7223 7.46521 14.5411 7.21441C14.4475 7.086 14.4355 6.78241 14.4355 6.29522V6.12722C14.4355 5.58722 14.0623 5.13963 13.5415 4.85282C13.0351 4.57323 12.2311 4.36083 11.5867 4.26002C11.2675 4.20962 10.9231 4.16522 10.5607 4.13521C10.1971 4.10282 9.90553 4.08241 9.70274 4.07281C9.49874 4.06321 9.31394 4.06321 9.12793 4.06321C8.80033 4.06321 8.46434 4.07642 8.11874 4.09921C7.77433 4.12201 7.34113 4.16401 6.80953 4.23121C5.75713 4.36681 4.77914 4.7148 4.28834 5.2224C4.00994 5.5116 3.90793 5.81521 3.90793 6.12601V6.32761C3.90793 6.69241 3.90552 6.7884 3.84553 7.0272C3.81674 7.14 3.78193 7.22881 3.72194 7.284C3.53473 7.44961 3.16394 7.62359 2.42114 7.6896C1.86314 7.7388 1.51034 7.6896 1.35074 7.5048C1.22714 7.3608 1.16833 7.1232 1.14674 6.876L1.13834 6.56639V6.23998L1.15634 5.89438C1.14075 5.39759 1.33393 4.94638 1.74914 4.53118C2.34195 3.93837 3.28034 3.48238 4.56194 3.14158C5.84594 2.79958 7.30394 2.62798 8.94074 2.62798C11.2495 2.62798 13.1767 2.94119 14.7259 3.55677C15.3355 3.80037 15.8479 4.05478 16.3448 4.44237C16.8476 4.83358 17.168 5.35438 17.168 5.91117V6.22438H17.1691L17.1691 6.22441Z" fill="#777777"/>
            </g>
            <defs>
            <clipPath id="clip0_32_217">
            <rect width="18" height="18" fill="white" transform="translate(0.149414 0.0936279)"/>
            </clipPath>
            </defs>
            </svg>
            <p className='textSecondary'>(11) 5026-8668</p>
            </CardItem>
            <p className='textMail'>comercial@tkgengates.com.br</p>
            <p className='textMail'>8:00h às 11:20h e 13:00h às 17:20h.</p>
            </ColumPrimary>

            <ColumPrimary>
            <p className='textPrimary'>Aceitamos</p>
            <CardItem>
            <img className='cards_icon' src={cardsIcon}/>
     
            </CardItem>

            </ColumPrimary>

            <ColumSecondary>
            <p className='textPrimary'>Segurança</p>
            <img src={securityData}/>
            <img src={securityCommerce}/>
            <p className='textAbout'>TKG - Especialistas em soluções de engate para veículos. Qualidade, segurança e confiança em cada produto.</p>

            </ColumSecondary>
        </Footer>
    )
    
}

export default FooterPayment